import { createRequest } from '../../../services/request';

export const VERIFY_ADDRESS = createRequest('CARRIERS/VERIFY_ADDRESS');
